import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { applyClientLang } from './utils/lang';

import i18n, { initI18n } from './i18n';


const root = ReactDOM.createRoot(document.getElementById('root'));

  await initI18n(); // apply stored lang and wait for i18n ready
  console.log('i18n ready, language before apply:', i18n.language);

  applyClientLang(); // ensure no flash
  console.log('language after applyClientLang:', i18n.language);

  root.render(
    <React.StrictMode>
      <AuthProvider> {/* Wrap the App */}
        <App />
      </AuthProvider>
    </React.StrictMode>
  );
  // If you want your app to work offline and load faster, can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: https://cra.link/PWA

serviceWorkerRegistration.register();